export default __webpack_public_path__ + "static/media/icon-arrow-down-dark.382e660d.svg";